import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validationScheme in access new member */
const UserDetailFormScheme = Yup.object().shape({
    // recoveryEmail: Yup.string()
    //     .test(
    //         'sameWord',
    //         'Recovery email must be different to regular email',
    //         (value, context) =>
    //             String(value).toLocaleLowerCase() !==
    //             String(context.parent.email).toLocaleLowerCase()
    //     )
    //     .email('Invalid email')
    //     .required('Email is required')
    //     .max(256, 'Email can have a maximum of 256 characters'),
    phoneNumber: Yup.number()
        .required('Phone number must be filled')
        .typeError('Phone number allow only numbers')
        .test('len', 'Phone number must be 7 character at minimum!', (val) => {
            if (val === undefined) {
                return true;
            }
            return val.toString().length >= 7;
        })
        .test('len', 'Phone number must be 16 character at maximum!', (val) => {
            if (val === undefined) {
                return true;
            }
            return val.toString().length <= 16;
        }),
});

export { UserDetailFormScheme };
